import * as svg from "../../../assets/close-solid-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const CloseSolidIcon = iconBuilder(svg, "CloseSolidIcon", "0 0 10 10");
